export const sidebarContent = theme => ({})
